// export const BASE_URL = 'http://192.168.0.97:3000/api';
// export const BASE_URL = 'http://192.168.29.182:3000/api';
// export const BASE_URL = 'https://app.insurality.com/api';
export const BASE_URL = 'https://dev.insurality.com/api';
